/* ============================================
   MediaLightbox — Fullscreen image viewer
   Dark backdrop, close/download, ESC to dismiss
   ============================================ */
import { useEffect, useCallback } from 'react'
import { IconX, IconDownload } from '@/components/icons/Icons'

interface MediaLightboxProps {
  src: string
  onClose: () => void
}

export default function MediaLightbox({ src, onClose }: MediaLightboxProps) {
  const handleKey = useCallback((e: KeyboardEvent) => {
    if (e.key === 'Escape') onClose()
  }, [onClose])

  useEffect(() => {
    document.addEventListener('keydown', handleKey)
    return () => document.removeEventListener('keydown', handleKey)
  }, [handleKey])

  const handleDownload = () => {
    const a = document.createElement('a')
    a.href = src
    a.download = src.split('/').pop() || 'download'
    a.target = '_blank'
    a.rel = 'noopener noreferrer'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  return (
    <div className="chat-lightbox" onClick={onClose}>
      <div className="chat-lightbox__actions">
        <button
          className="chat-lightbox__btn"
          onClick={(e) => { e.stopPropagation(); handleDownload() }}
          type="button"
          title="Descargar"
        >
          <IconDownload size={20} />
        </button>
        <button
          className="chat-lightbox__btn"
          onClick={onClose}
          type="button"
          title="Cerrar"
        >
          <IconX size={20} />
        </button>
      </div>
      <img
        src={src}
        alt="Media"
        className="chat-lightbox__img"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  )
}
